module.exports = __webpack_public_path__ + "img/index_bookBtn01.77e94200.png";